import React, { useState, useEffect } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { fetchBenefiss } from "../../../Benefis/_redux/benefis/benefisAction";
import AddIcon from "@material-ui/icons/Add";

export default function ModalBenefis({ show, onHide, setSelectedBenefis }) {
  const { currentState } = useSelector(
    (state) => ({ currentState: state.benefis }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(fetchBenefiss(queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, dispatch]);

  const [queryParams, setQueryParams] = useState({
    filter: {
      name: "",
    },
    pageNumber: 1,
    pageSize: 10,
  });

  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "benefis_category.name",
      text: "Kategori",
      sort: true,
    },
    {
      dataField: "type",
      text: "Tipe",
      sort: true,
    },
    {
      dataField: "qty",
      text: "Jumlah",
      sort: true,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: (cell, row) => {
        return (
          <>
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Pilih</Tooltip>}
            >
              <a
                className="btn btn-icon btn-light btn-hover-success btn-sm mx-3"
                onClick={() => setSelectedBenefis(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-success">
                  <AddIcon />
                </span>
              </a>
            </OverlayTrigger>
          </>
        );
      },
      classes: "text-right",
      headerClasses: "text-right",
    },
  ];

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "20", value: 20 },
    { text: "50", value: 50 },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header>
          <h4>Pilih Benefis</h4>
        </Modal.Header>
        <Modal.Body>
          <PaginationProvider pagination={paginationFactory(paginationOptions)}>
            {({ paginationProps, paginationTableProps }) => {
              return (
                <Pagination
                  isLoading={listLoading}
                  paginationProps={paginationProps}
                >
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    bordered={false}
                    remote
                    keyField="uuid"
                    data={entities === null ? [] : entities}
                    columns={columns}
                    onTableChange={getHandlerTableChange(setQueryParams)}
                    {...paginationTableProps}
                  >
                    <PleaseWaitMessage entities={entities} />
                    <NoRecordsFoundMessage entities={entities} />
                  </BootstrapTable>
                </Pagination>
              );
            }}
          </PaginationProvider>
        </Modal.Body>
      </Modal>
    </>
  );
}
